import { toExcelDate, toExcelInteger, toExcelQuantity } from 'components/xlsx/excelCells';
import { ClassifierData } from 'types/classifiers';
import { t } from 'utils/getTranslations';
import { DebriefingExportItem, DebriefingLessonListItem } from '../types';

function lessonsColumn(lessons: DebriefingLessonListItem[] | null): string {
    return (lessons ?? [])
        .map((lesson) => `[${t(`debriefing.relevance.${lesson.relevance}`)}] ${lesson.description}`)
        .join('; ');
}

export const mapDebriefingsToCSVFormat = (
    debriefings: DebriefingExportItem[],
    _classifiers: Record<string, ClassifierData>
) => {
    return debriefings?.map((debriefing) => ({
        [t('debriefing.export.date')]: toExcelDate(debriefing.debriefingDate),
        [t('debriefing.export.type')]: t(`debriefing.type.${debriefing.debriefingType}`),
        [t('debriefing.export.cases')]: (debriefing.matters ?? []).join('; '),
        [t('debriefing.export.client')]: debriefing.clientName ?? '',
        [t('debriefing.export.project-name')]: debriefing.projectName ?? '',
        [t('debriefing.export.session-leader')]: debriefing.sessionLeader ?? '',
        [t('debriefing.export.participants')]: (debriefing.participants ?? []).join(', '),
        [t('debriefing.export.confidential')]: debriefing.isConfidential ? t('yes') : t('no'),
        [t('debriefing.export.did-well')]: lessonsColumn(debriefing.lessonsDidWell),
        [t('debriefing.export.could-improve')]: lessonsColumn(debriefing.lessonsCouldImprove),
        [t('debriefing.score-categories.scope')]: toExcelInteger(debriefing.scoreScopeMgmt),
        [t('debriefing.score-categories.team')]: toExcelInteger(debriefing.scoreTeamComposition),
        [t('debriefing.score-categories.deadlines')]: toExcelInteger(debriefing.scoreDeadlinesMgmt),
        [t('debriefing.score-categories.budget')]: toExcelInteger(debriefing.scoreBudgetMgmt),
        [t('debriefing.score-categories.communication')]: toExcelInteger(debriefing.scoreCommunication),
        [t('debriefing.score-categories.general')]: toExcelInteger(debriefing.scoreGeneralPerformance),
        [t('debriefing.score-categories.overall')]: toExcelQuantity(debriefing.overallRating),
        [t('debriefing.export.tasks-done')]: toExcelInteger(debriefing.taskDoneCount ?? 0),
        [t('debriefing.export.tasks-total')]: toExcelInteger(debriefing.taskTotalCount ?? 0),
    }));
};
